import { Card, Attachment } from "@/components/shared";
import { fileUrl, downloadFile } from "@/lib/api";
import { CheckSquare, Square, Download } from "lucide-react";

export function PhotoCard({ photo: p, selected, selectMode, showFolder, onOpen, onToggle }) {
  return (
    <Card data-testid={`photo-${p.id}`} className={`p-0 overflow-hidden group relative ${selected ? "!border-[#FF5722] ring-2 ring-[#FF5722]" : ""}`}
      draggable={selectMode && selected} onDragStart={(e) => e.dataTransfer.setData("text/plain", "photos")}>
      <div className="aspect-square bg-zinc-950 overflow-hidden" onClick={() => (selectMode ? onToggle() : onOpen())}>
        <Attachment src={fileUrl(p.file_id)} className="w-full h-full object-cover group-hover:scale-105 transition-transform cursor-pointer" />
      </div>
      {selectMode && (
        <button data-testid={`photo-select-${p.id}`} onClick={onToggle} className={`absolute top-2 left-2 w-7 h-7 border-2 border-black flex items-center justify-center ${selected ? "bg-[#FF5722] text-black" : "bg-black/70 text-white"}`}>
          {selected ? <CheckSquare size={16} /> : <Square size={16} />}
        </button>
      )}
      <div className="p-2 flex items-center justify-between gap-2 border-t border-zinc-800">
        <span className="font-mono text-[10px] text-zinc-500 truncate">
          {p.checklist_key ? <span className="text-emerald-400">✓ {p.caption}</span> : <>{showFolder && p.folder ? <span className="text-[#FF5722]">{p.folder} · </span> : null}{p.uploaded_by}</>}
        </span>
        <button data-testid={`photo-save-${p.id}`} onClick={() => downloadFile(fileUrl(p.file_id), p.caption || `photo_${p.id}.jpg`)} className="text-zinc-500 hover:text-[#FF5722] shrink-0" title="Save"><Download size={13} /></button>
      </div>
    </Card>
  );
}
